import InfiniteScroll from "react-infinite-scroll-component";
import { ProgressSpinner } from "primereact/progressspinner";
import { useCallback, useEffect, useRef, useState } from "react";
import { Checkbox } from "primereact/checkbox";

import { getCodesList } from "services";
import {
  addCodes,
  nextPageCodes,
  setCodes,
  setFirstLoadCodes,
  setHasNextPageCodes,
  setLoadingCodes,
} from "store/slicer/GestioneCodeSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { SourceRequestInterface } from "interfaces";
import { InputSearchCode } from "components/shared";
import { EmptyCodesList } from "pages/account/pages/detailProjectPage/components";

export const FormAddCode = ({
  setValue,
  watch,
  projectId,
}: {
  setValue: any;
  watch: any;
  projectId: string;
}) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.gestioneCodeSlice.filters);
  const listCodes = useAppSelector((state) => state.gestioneCodeSlice.codes);
  const hasNextPage = useAppSelector(
    (state) => state.gestioneCodeSlice.hasNextPage
  );
  const loadingCodes = useAppSelector(
    (state) => state.gestioneCodeSlice.loading
  );
  const firstLoad = useAppSelector(
    (state) => state.gestioneCodeSlice.firstLoad
  );
  const sourceIdsList = watch("sourceIdsList");
  const [hasMore, setHasMore] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  const fetchMoreData = useCallback(() => {
    if (!firstLoad && !loadingCodes && hasNextPage) {
      dispatch(nextPageCodes());
    }
  }, [dispatch, firstLoad, loadingCodes, hasNextPage]);

  const checkLayout = useCallback(() => {
    if (hasNextPage !== undefined) setHasMore(hasNextPage);
    setTimeout(() => {
      if (containerRef.current && hasNextPage) {
        if (containerRef.current?.scrollHeight <= 400) {
          if (!firstLoad && !loadingCodes && hasNextPage) {
            dispatch(nextPageCodes());
          }
        }
      }
    }, 200);
  }, [dispatch, hasNextPage, firstLoad, loadingCodes]);

  useEffect(() => {
    checkLayout();
  }, [checkLayout]);

  useEffect(() => {
    if (filters.pageIndex > 0) {
      dispatch(setLoadingCodes(true));
      if (filters.pageIndex === 1) {
        dispatch(setHasNextPageCodes(true));
      }
      getCodesList(projectId, filters)
        .then((response: any) => {
          const checkHasNextPage = response.data.hasNextPage;
          if (filters.pageIndex === 1) {
            dispatch(setCodes(response.data));
            if (checkHasNextPage) {
              dispatch(nextPageCodes());
            } else {
              dispatch(setHasNextPageCodes(checkHasNextPage));
            }
          } else {
            dispatch(setHasNextPageCodes(checkHasNextPage));
            setHasMore(checkHasNextPage);
            checkLayout();
            dispatch(addCodes(response.data.items ?? []));
          }
        })
        .catch((_) => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters]);

  useEffect(() => {
    if (!hasNextPage || filters.pageIndex > 1) {
      dispatch(setLoadingCodes(false));
      dispatch(setFirstLoadCodes(false));
      setHasMore(hasNextPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNextPage, filters.pageIndex]);

  const handleCodeChange = (code: SourceRequestInterface) => {
    const isSelected = sourceIdsList.includes(code.id);

    if (isSelected) {
      setValue(
        "sourceIdsList",
        sourceIdsList.filter((id: string) => id !== code.id)
      );
    } else {
      setValue("sourceIdsList", [...sourceIdsList, code.id]);
    }
  };

  return (
    <div className="flex-column">
      <div className="width-100 height-100 margin-top-2">
        <InputSearchCode />
        <div
          className={`margin-top-18 ${
            !listCodes?.items?.length ? "empty-codes-list" : ""
          }`}
          id="scroll-codes-div"
          ref={containerRef}
        >
          <InfiniteScroll
            style={{ overflow: "hidden" }}
            dataLength={listCodes.items?.length ?? 0}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              loadingCodes && (
                <div className="spinner-wrapper">
                  <ProgressSpinner className="custom-spinner" />
                </div>
              )
            }
            scrollableTarget="scroll-codes-div"
          >
            {listCodes?.items?.length
              ? listCodes.items?.map((code: any) => {
                  return (
                    <div
                      key={code.id}
                      className="flex-container align-center form-add-code"
                    >
                      <Checkbox
                        key={code.id}
                        name="code"
                        value={code.id}
                        onChange={() => handleCodeChange(code)}
                        checked={sourceIdsList.includes(code.id)}
                      />
                      <span className="margin-left-28">{code.name}</span>
                    </div>
                  );
                })
              : !listCodes?.items?.length &&
                !firstLoad &&
                !loadingCodes && <EmptyCodesList />}
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};
